import { makeStyles, Theme } from '@material-ui/core/styles';

export default makeStyles((theme: Theme) => ({
    sidebarTitle: {
        color: '#428302',
        marginLeft: '5px',
    },
    paper: {
        paddingLeft: '25px',
        paddingRight: '25px',
        paddingBottom: '20px',
    },
    paperHeader: {
        padding: '0',
        flexDirection: 'row-reverse',
    },
    paperHeaderIcon: {
        color: '#428302',
    },
    gridContainer: {
        width: '100%',
    },
    /** One row per SIU subservice: label left, narrow controls right. */
    serviceTypeRow: {
        paddingTop: theme.spacing(0.5),
    },
    serviceTypeDivider: {
        borderBottom: `1px solid ${theme.palette.divider}`,
        paddingBottom: theme.spacing(2),
        marginBottom: theme.spacing(1),
    },
    serviceLabelCell: {
        display: 'flex',
        alignItems: 'center',
        minWidth: 0,
        [theme.breakpoints.up('sm')]: {
            maxWidth: 230,
            flexBasis: 210,
            flexShrink: 0,
        },
    },
    serviceLabelText: {
        fontWeight: 600,
        fontSize: '0.95rem',
        color: theme.palette.text.primary,
        display: 'inline-flex',
        alignItems: 'center',
        lineHeight: 1.35,
        letterSpacing: 0.01,
    },
    serviceInfoIcon: {
        marginLeft: theme.spacing(0.75),
        fontSize: '1.1rem',
        color: theme.palette.text.secondary,
        cursor: 'help',
    },
    serviceControlsCell: {
        flex: '1 1 0',
        minWidth: 0,
    },
    /** Two fixed-width columns: dropdowns align; numeric fields align; Manned puts number in first column. */
    controlColumns: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(2),
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            flexDirection: 'row',
            flexWrap: 'nowrap',
            alignItems: 'flex-start',
            columnGap: theme.spacing(2),
        },
    },
    /** First column: selects + Manned days (~40% narrower than prior 320px). */
    ctrlColDropdown: {
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            width: 192,
            minWidth: 192,
            flexShrink: 0,
        },
    },
    /** Wide enough for "Number of facilities" label on one line; dropdown column stays at 192px separately. */
    ctrlColNumeric: {
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            width: 180,
            minWidth: 180,
            flexShrink: 0,
        },
    },
    inlineFormControl: {
        marginTop: 0,
        marginBottom: 0,
        verticalAlign: 'top',
    },
    /** Force all first-column selects (and Manned TextField) to fill ctrlColDropdown; MUI Select often shrinks to label width otherwise. */
    firstColumnControl: {
        width: '100%',
        maxWidth: '100%',
        boxSizing: 'border-box',
        display: 'block',
        '& .MuiInputBase-root': {
            width: '100%',
        },
        '& .MuiSelect-select': {
            width: '100%',
            maxWidth: '100%',
            boxSizing: 'border-box',
        },
        '& .MuiSelect-select:focus': {
            backgroundColor: 'transparent',
        },
    },
    narrowTextField: {
        width: '100%',
        maxWidth: '100%',
        marginTop: 0,
        marginBottom: 0,
        verticalAlign: 'top',
        '& .MuiInputBase-input': {
            textAlign: 'right',
            paddingRight: theme.spacing(0.5),
        },
    },
    facilityTypesInline: {
        alignSelf: 'center',
        marginRight: theme.spacing(3),
        maxWidth: 280,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        [theme.breakpoints.down('xs')]: {
            whiteSpace: 'normal',
            maxWidth: '100%',
            marginRight: 0,
            marginBottom: theme.spacing(0.5),
        },
    },
}));
